import React from 'react';
import { useParams } from 'react-router-dom';
import { Drawer } from '../../components';
import FormMapping from '../../components/FormMapping';
import { useStyles } from '../../services/material-ui';

export interface IDistributorRouteParams {
  id: string;
}
const CreateDistributorMapping: React.FC = () => {
  const classes = useStyles();

  const { id: distributorId } = useParams<IDistributorRouteParams>();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <h1>Configure o mapeamento do arquivo de frete</h1>

        <div>
          <FormMapping distributorId={distributorId} />
        </div>
      </main>
    </div>
  );
};

export default CreateDistributorMapping;
